import styled, { css } from "styled-components"

export const P = styled.p`
  color: ${(props) => props.theme.colors.fields.contentHeading};
  font-size: 16px;
  margin: 0;
  padding: 0;
  font-weight: 400;
`
export const A = styled.a`
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;
  color: ${(props) => props.theme.colors.home.headings};
  text-decoration: none;

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.currentPage
      ? css`
          font-weight: 500;
        `
      : css`
          color: #666;
        `}
`

export const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${({ preTitle }) =>
    preTitle &&
    css`
      margin-bottom: 16px;
    `}
`

export const Icon = styled.span`
  color: #999;
  line-height: 100%;
  font-weight: 400;
  padding: 0 9px;
  svg {
    font-size: 16px;
  }
`
